import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import { useStudentInvoices } from "../../../hooks/api/education/useBilling";

interface StudentStatementProps {
  studentId: string;
}

const StudentStatement: React.FC<StudentStatementProps> = ({ studentId }) => {
  const { t } = useKivunovaTranslation();
  const { data: invoices = [], isPending } = useStudentInvoices(studentId);

  if (isPending) {
    return (
      <CommonLoader
        loadingMessage={t("loading-statement", "Loading statement...")}
      />
    );
  }

  return (
    <Box data-testid="student-statement" sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {t("student-statement-title", "Fee statement")}
      </Typography>
      {invoices.length === 0 ? (
        <Typography color="text.secondary">
          {t("student-statement-empty", "No invoices for this student yet.")}
        </Typography>
      ) : (
        <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none" }}>
          {invoices.map((invoice) => (
            <Box
              component="li"
              key={invoice.invoiceId}
              sx={{ py: 1, borderBottom: "1px solid", borderColor: "divider" }}
            >
              <Typography fontWeight={600}>{invoice.invoiceNumber}</Typography>
              <Typography variant="body2" color="text.secondary">
                {t("invoice-balance", "Balance")}:{" "}
                {invoice.remainingAmount ?? 0} · {invoice.status}
                {invoice.dueDate
                  ? ` · ${t("due-date", "Due")} ${invoice.dueDate}`
                  : ""}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default StudentStatement;
